'server-only';

import { createIntl, IntlShape } from '@formatjs/intl';
import { getIntlMessages, getLocale } from '../context/LanguageServerContext';
import { LanguageCode } from '@elsevier-health/osmosis-shared/languages';

const intlMap: Record<string, IntlShape> = {};

/**
 * Retrieves the internationalization messages for the specified locale.
 * @returns {Promise<IntlShape>} - A promise that resolves to the `IntlShape` object.
 */
export default function getServerIntl() {
  const locale = getLocale();
  if (intlMap[locale]) return intlMap[locale];

  const messages = locale === LanguageCode.EN ? {} : getIntlMessages();

  const intl = createIntl({
    locale,
    messages,
  });

  intlMap[locale] = intl;

  return intl;
}
